export const FAVORITE_ASSET_LIMIT = 10;
export const FAVORITE_ACTION_LOCATIONS = {
  SINGLE_ASSET_VIEW: 'single-asset-view',
  ASSET_LIST_PAGE: 'asset-list-page'
};